import React from 'react';
import moment from 'moment';

import { Typography, Chip, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { AdvancedMarker, AdvancedMarkerAnchorPoint, Pin, InfoWindow, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';

import { getEventColor } from 'pages/Scheduling/components/resources';

export default function MapMarkerWithInfoWindow({
  services,
  address,
  startDateTime,
  endDateTime,
  situationId,
  isOpen = false,
  setIsOpen,
  getDirections,
  noSchedulingLayout,
  ...props
}) {
  const [markerRef, marker] = useAdvancedMarkerRef();

  const isManyDays = moment(startDateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(endDateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');

  return(
    <>
      <AdvancedMarker
        {...props}
        ref={markerRef}
        anchorPoint={AdvancedMarkerAnchorPoint.TOP}
      >
        <Pin
          scale={1.5}
          background={getEventColor(situationId)}
          glyphColor='#FFFFFF'
          borderColor='#FFFFFF'
        />
      </AdvancedMarker>
      {isOpen && (
        <InfoWindow
          headerDisabled
          anchor={marker}
          minWidth={250}
        >
          <IconButton
            style={{ position: 'absolute', top: 5, right: 5 }}
            onClick={() => setIsOpen(false)}
          >
            <Close />
          </IconButton>
          {noSchedulingLayout ? (
            <>
              {noSchedulingLayout}
            </>
          ) : (
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 10 }}>
                  <Typography color='primary'>
                    <b>{services[0]?.serviceName || '-'}</b>
                  </Typography>
                  {(services?.length > 1) && (
                    <Chip
                      style={{ backgroundColor: 'rgba(2, 42, 92, 0.18)', height: 20 }}
                      label={
                        <Typography color='primary'>+ {services?.length}</Typography>
                      }
                    />
                  )}
                </div>
                {!!address && (
                  <Typography color='textSecondary'>
                    <b>{address}</b>
                  </Typography>
                )}
                {isManyDays && (
                  <Typography color='textSecondary'>
                    <b>{moment(startDateTime, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {moment(endDateTime, 'YYYY-MM-DD').format('DD/MM/YYYY')}</b>
                  </Typography>
                )}
                {!isManyDays && (
                  <Typography color='textSecondary'>
                    <b>{moment(startDateTime, 'YYYY-MM-DD').format('DD/MM/YYYY')}</b>
                  </Typography>
                )}
                <Typography color='textSecondary'>
                  <b>{moment(startDateTime, 'YYYY-MM-DD HH:mm:ss').format('hh:mma')} - {moment(endDateTime, 'YYYY-MM-DD HH:mm:ss').format('hh:mma')}</b>
                </Typography>
              </div>
              <button
                style={{ backgroundColor: '#1E5168', color: '#FFFFFF', height: 32, width: 32, border: 0, borderRadius: '50%', marginLeft: 20, cursor: 'pointer' }}
                onClick={getDirections}
              >
                <b>IR</b>
              </button>
            </div>
          )}
        </InfoWindow>
      )}
    </>
  );
}